import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LicenseService {
  private appRoot=environment.clientRoot;
  private primaryLicenseUrl = `${this.appRoot}/3rdpartylicenses.txt`;
  private fallbackLicenseUrl = 'assets/3rdpartylicenses.txt';

  constructor(private http: HttpClient) {}

  getLicenses(): Observable<any[]> {
    return this.http
      .get(this.primaryLicenseUrl, { responseType: 'text' })
      .pipe(
        catchError(() =>
          this.http.get(this.fallbackLicenseUrl, { responseType: 'text' })
        ),
        map((data) => this.parseLicenses(data || ''))
      );
  }

  private parseLicenses(data: string): any[] {
    const licenses = [];
    const lines = data.split('\n');
    let currentLicense = { name: '', license: '' };
    let emptyLineCount = 0;

    lines.forEach(line => {
      if (line.trim() === '') {
        emptyLineCount++;
        return;
      }
      if (line.startsWith('@') || emptyLineCount >= 2) {
        if (currentLicense.name) {
          licenses.push({ ...currentLicense });
        }
        currentLicense = { name: line.trim(), license: '' };
        emptyLineCount = 0;
      } else {
        currentLicense.license += line.trim() + '\n';
        emptyLineCount = 0;
      }
    });

    if (currentLicense.name) {
      licenses.push({ ...currentLicense });
    }

    return licenses;
  }
}
